import { getMethod } from "../../../../function/helper";

const getProvince = async set => {
  const province = await getMethod("/address/v1/province/show/1");
  if (province) {
    set(province.data);
  }
};

export default getProvince;
